import styled, { css } from 'styled-components';
import { getSizeInPx, getSizeInRem } from '../methods/common.js';
import '../mixins/style-mixins.js';
import { scrollBarStyle__hidden } from '../mixins/scrollbar.js';
import '../mixins/cursor.js';
import '../mixins/font.js';

const Container = styled.div `
    display: ${({ display }) => display};
    gap: ${({ gap }) => getSizeInPx(gap)};

    margin: ${({ margin }) => { var _a; return (_a = getSizeInRem(margin)) !== null && _a !== void 0 ? _a : "0"; }};
    padding: ${({ padding }) => { var _a; return (_a = getSizeInRem(padding)) !== null && _a !== void 0 ? _a : "0"; }};
    border: ${({ border }) => border};

    ${({ width, height, borderRadius }) => css({
    width: getSizeInRem(width),
    height: getSizeInRem(height),
    borderRadius: getSizeInRem(borderRadius),
})};

    ${({ gridAutoFlow, gridTemplateColumns, gridTemplateRows, alignItems, justifyContent, }) => css({
    gridAutoFlow,
    gridTemplateColumns,
    gridTemplateRows,
    alignItems,
    justifyContent,
})};

    ${({ hideScrollBar }) => hideScrollBar && scrollBarStyle__hidden};
`;

export { Container as default };
//# sourceMappingURL=Container.js.map
